<template>
  <div class="news">
    <div class="news-list" v-for="(item, index) in newList" :key="index">
      <div
        v-if="item.href == ''"
        class="news-list-item"
        @click="gotoDetial(item)"
      >
        <div class="new-list-left">
          <img :src="item.pic" alt="" />
          <!-- <video v-else :src="item.href" :poster="item.pic"></video> -->
          <!-- <iframe v-else :src="item.href" frameborder="0" disabled></iframe> -->
        </div>
        <div class="new-list-right">
          <div class="new-list-right-title">{{ item.title }}</div>
          <div class="new-list-right-content">{{ item.field4 }}</div>
          <div class="new-list-right-bottom">
            <div class="new-list-right-bottom-left">
              {{ item.field1 ? "出处：" + item.field1 : "" }}
            </div>
            <div class="new-list-right-bottom-right">
              发布日期：{{ item.publishTime }}
            </div>
          </div>
        </div>
      </div>
      <a v-else class="news-list-item" target="_blank" :href="item.href">
        <div class="new-list-left">
          <img :src="item.pic" alt="" />
        </div>
        <div class="new-list-right">
          <div class="new-list-right-title">{{ item.title }}</div>
          <div class="new-list-right-content">{{ item.field4 }}</div>
          <div class="new-list-right-bottom">
            <div class="new-list-right-bottom-left">
              {{ item.field1 ? "出处：" + item.field1 : "" }}
            </div>
            <div class="new-list-right-bottom-right">
              发布日期：{{ item.publishTime }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <a-pagination
      :default-current="1"
      :total="total"
      hideOnSinglePage
      @change="onShowSizeChange"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    newList: Array,
    siteName: String,
    total: Number,
  },
  methods: {
    gotoDetial(item) {
      const id = item._id;
      if (item.hrefType == 1) {
      } else {
        if (this.siteName == "civilizationColumn") {
          this.$router.push(`/civilization-column/detail/${id}`);
        } else if (this.siteName == "newEraTheory") {
          this.$router.push(`/new-era-theory/detail/${id}`);
        } else if (this.siteName == "civilizationCreation") {
          this.$router.push(`/civilization-creation/detail/${id}`);
        } else if (this.siteName == "chinesePeople") {
          this.$router.push(`/chinese-people/detail/${id}`);
        } else if (this.siteName == "jinZhongPeople") {
          this.$router.push(`/jinzhong-people/detail/${id}`);
        } else if (this.siteName == "moralModel") {
          this.$router.push(`/moral-model/detail/${id}`);
        } else if (this.siteName == "shanXiPeople") {
          this.$router.push(`/shanxi-people/detail/${id}`);
        } else if (this.siteName == "jz-heritage") {
          this.$router.push(`/jz-heritage/detail/${id}`);
        } else if (this.siteName == "jz-red") {
          this.$router.push(`/jz-red/detail/${id}`);
        } else if (this.siteName == "jz-treasure") {
          this.$router.push(`/jz-treasure/detail/${id}`);
        } else if (this.siteName == "jz-story") {
          this.$router.push(`/jz-story/detail/${id}`);
        } else if (this.siteName == "five-plateform-culture") {
          this.$router.push(`/five-plateform-culture/detail/${id}`);
        } else if (this.siteName == "five-plateform-education") {
          this.$router.push(`/five-plateform-education/detail/${id}`);
        } else if (this.siteName == "five-plateform-healthy") {
          this.$router.push(`/five-plateform-healthy/detail/${id}`);
        } else if (this.siteName == "five-plateform-technology") {
          this.$router.push(`/five-plateform-technology/detail/${id}`);
        } else if (this.siteName == "five-plateform-theory") {
          this.$router.push(`/five-plateform-theory/detail/${id}`);
        }
      }
    },
    onShowSizeChange(e) {
      this.$emit("page", e);
    },
  },
};
</script>

<style lang="scss">
.news {
  margin-bottom: 40px;
}
.news-list {
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
  margin-bottom: 40px;
  background: #ffffff;
  .news-list-item {
    display: flex;
  }

  .new-list-left {
    width: 350px;
    height: 230px;
    display: table-cell;
    vertical-align: middle;
    display: flex;
    align-items: center;
    img {
      max-width: 100%;
      max-height: 100%;
      display: block;
      margin: auto;
    }
    video {
      max-width: 100%;
      max-height: 100%;
      display: block;
      margin: auto;
    }
  }
  .new-list-right {
    padding: 40px 20px 30px 20px;
    text-align: left;
    flex: 1;
    .new-list-right-title {
      font-size: 20px;
      font-family: Helvetica;
      color: #333333;
      line-height: 20px;
    }
    .new-list-right-content {
      height: 81px;
      margin-top: 12px;
      font-size: 16px;
      font-family: Helvetica;
      color: #333333;
      line-height: 26px;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
    .new-list-right-bottom {
      margin-top: 22px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      font-family: Helvetica;
      color: #727384;
      line-height: 14px;
      .new-list-right-bottom-left {
      }
      .new-list-right-bottom-right {
      }
    }
  }
}
</style>